// extracted by mini-css-extract-plugin
export var videoRowContainer = "video-wrapper-module--video-row-container--7DwHX";
export var videoWrapper = "video-wrapper-module--video-wrapper--1NsqF";